module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cp_stills_pet_500_aq_pom.206fd76c.png";